const values = Object.freeze({
  applicationName: 'SolidOps',
  apiBaseUrl: '/api/v1',
});

export const globals = Object.freeze({
  get applicationName() {
    return values.applicationName;
  },
  get apiBaseUrl() {
    return values.apiBaseUrl;
  },
});
